import React from 'react';

// @ts-ignore
import ProgressItemsField from "../progress-items";
import SelectProgress from "../../../../gd-ui/select-progress/common";
import Project from "../../../../model2/project/project";
import Task from "../../../../model2/task/task";

type Props = {
    item                : Task | Project,
    onProgressSelect    : callback,
    className?          : string
}

export default function ProgressItemsInList(props:Props) {

    const value = props.item.progressSubItems.total ? gd.utils.floorToDecimals(100 * props.item.progressSubItems.done/props.item.progressSubItems.total, 0) : null

    return (
        <SelectProgress renderValue="bar-50"
                        className={props.className}
                        notSetPlaceholder=""
                        underlined="on-hover"
                        value={value}
                        valueLabel={ProgressItemsField.getValue(props.item)}
                        disabled={true}
                        deleteButton={false} />
    );
}
